import { onError } from '@apollo/client/link/error'
import Bugsnag from '@bugsnag/js'
import { global } from '@navinc/utils'
import { getDecodedToken } from '../../utils/tokens'

// These are GraphQL error messages we are comfortable ignoring and not sending to Bugsnag
const MESSAGES_TO_IGNORE = ['PersistedQueryNotFound']

export const createErrorLink = function createErrorLink() {
  return onError(({ graphQLErrors, networkError, operation, ...rest }) => {
    // 401's happen all the time. They tend to cause us to reach our Bugsnag limits.
    if (networkError?.response?.status !== 401) {
      const { authUserId, capabilities, iss: partnerId } = getDecodedToken()
      const metadata = { authUserId, partnerId, capabilities }
      const { operationName, query } = operation
      const defaultGraphQLMetadata = { operationName, query: query?.loc?.source?.body }
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) => {
          if (MESSAGES_TO_IGNORE.includes(message)) {
            // Only output an info message for those we're ignoring
            console.info(`[GraphQL Info]: Message: ${message}, Path: ${path}`, locations)
          } else {
            console.error(`[GraphQL Error]: Message: ${message}, Path: ${path}`, locations)
            const displayMessage = `GraphQL: ${message || 'Unknown'} (${operationName})`
            Bugsnag.notify(new Error(displayMessage), (event) => {
              event.context = global.location.pathname
              event.groupingHash = displayMessage
              event.addMetadata('GraphQL Request', {
                ...defaultGraphQLMetadata,
                message,
                locations,
                path,
              })
              event.addMetadata('Metadata', metadata)
            })
          }
        })
      }

      if (networkError) {
        console.error(`[GraphQL Network Error][${operationName}]: ${networkError}`)

        Bugsnag.notify(networkError, (event) => {
          event.context = global.location.pathname
          event.addMetadata('GraphQL Request', defaultGraphQLMetadata)
          event.addMetadata('Metadata', metadata)
        })
      }
    }
  })
}
